<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.roadmap.text") }}</h1>

      <div role="tablist">
        <b-card no-body class="custom-accordion shadow-none mb-3">
          <!-- <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.roadmap.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header> -->

          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.roadmap.line-1") }}
            </p>
            <p class="mb-3">
              {{ $t("help.platform.roadmap.line-2") }}
            </p>

            <img src="@/assets/images/help/bgys-roadmap.png" class="image" />

            <p class="mt-3">
              {{ $t("help.platform.roadmap.line-3") }}
            </p>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
